import { useLoaderData } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'

import { loader as contentLoader } from './loader'
import { DesktopView } from './views/desktop'
import { MobileView } from './views/mobile'
import appDefaults from '~/app.defaults.json'
import { ErrorBoundaryComponent } from '~/components/ErrorBoundary'
import { useConsumerBranding } from '~/hooks/useConsumerBranding'
import { PortalRouteHandle } from '~/types/app'
import { LayoutType } from '~/types/layout'

export const loader = contentLoader

export const handle: PortalRouteHandle = {
  layout: {
    [LayoutType.DEFAULT]: {
      consumerTopBar: {
        search: {
          disabled: false
        }
      },
      previewTopBar: {
        productContent: {
          disabled: true
        }
      }
    }
  },
  breadcrumb: ({ match }) =>
    match.data?.currentProduct?.name
}

export default function DocsLayout() {
  const { sections } = useLoaderData<typeof contentLoader>()

  const branding = useConsumerBranding()

  const { items } = sections
  const tableOfContents = items[0]?.tableOfContents || []

  const isMobile = useMediaQuery(appDefaults.media.mobile, { initializeWithValue: false })

  return (
    
    isMobile ? <MobileView
      tableOfContents={tableOfContents}
      branding={branding}
    /> :
      <DesktopView
        tableOfContents={tableOfContents}
        branding={branding}
      />
  )
}

export const ErrorBoundary = ErrorBoundaryComponent